(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('agw-icon-autoplay')) {
    customElements.define('agw-icon-autoplay', class extends HTMLElement {
      async connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.carousel = this.querySelector('text-with-icons-carousel');
        this.button = this.querySelector('.agw-icon-playback');
        if (this.dataset.enabled !== 'true' || !this.carousel || !this.button) return;
        await customElements.whenDefined('text-with-icons-carousel');
        if (signal.aborted || !this.isConnected) return;
        this.mobile = matchMedia('(max-width: 699px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.inView = false;
        this.hovered = false;
        this.moving = false;
        const listen = (target, name, fn) => target.addEventListener(name, fn, { signal });
        const pause = () => { this.paused = true; this.schedule(); };
        listen(this.button, 'click', () => { this.paused = !this.paused; this.schedule(); });
        listen(this.carousel, 'pointerdown', pause);
        listen(this.querySelector('carousel-navigation'), 'click', pause);
        listen(this, 'focusin', (event) => { if (event.target !== this.button) pause(); });
        listen(this, 'pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
        listen(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
        listen(this.carousel, 'carousel:change', () => { this.moving = true; clearTimeout(this.timer); });
        listen(this.carousel, 'carousel:settle', () => { this.moving = false; this.schedule(); });
        listen(this.mobile, 'change', () => this.schedule());
        listen(this.motion, 'change', () => { this.paused = this.motion.matches; this.schedule(); });
        listen(document, 'visibilitychange', () => this.schedule());
        listen(this.closest('.shopify-section'), 'shopify:block:select', pause);
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.25;
          this.schedule();
        }, { threshold: [0, 0.25] });
        this.observer.observe(this.carousel);
        this.button.hidden = false;
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        this.button.textContent = this.paused ? this.button.dataset.play : this.button.dataset.pause;
        if (!this.isConnected || this.paused || this.hovered || this.moving || !this.mobile.matches || !this.inView || document.hidden) return;
        this.timer = setTimeout(() => this.carousel.next(), Number(this.dataset.interval) || 4000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
